import { Agreement } from './agreement.model';
export class AgreementResponse {
    errorCode: number;
    errorDescription: string;
    errorMessage: string;
    response: Agreement;
}
